  
import React from 'react';
import { Container, IconContainer, TextContainer, ErrorText, IconText } from './style';

  const ColorContrastValidator = ({containerBackgroundColor  = "#E6F4FF", textColor = "#333333", containerText =  "ABC",  containerSize = "40px", fontSize = "14px"}) =>{
  
  
  return (
    <Container>
      <IconContainer backgroundColor={containerBackgroundColor} size={containerSize}>
        {containerText && (
          <IconText textColor={textColor} fontSize={fontSize}>
            {containerText}
          </IconText>
        )}
      </IconContainer>
      {/* <TextContainer>
        <ErrorText>{errorMessage}</ErrorText>
      </TextContainer> */}
    </Container>
  );
};

export default ColorContrastValidator;